export function stripAngleBlocks(
    input: string,
    options?: { collapseWhitespace?: boolean }
  ): string {
    let depth = 0;
    let out = "";
  
    for (let i = 0; i < input.length; i++) {
      const ch = input[i];
  
      if (ch === "<") {
        depth++;
        continue;
      }
      if (ch === ">") {
        if (depth > 0) depth--;
        else {
          out += ch;
        }
        continue;
      }
  
      if (depth === 0) out += ch;
    }
  
    if (options?.collapseWhitespace) {
      out = out.replace(/\s+/g, " ").trim();
    }
  
    return out;
  }